import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Pagination from "rc-pagination";
import ImageLoader from "react-imageloader";
import styled from "styled-components";
import Modal from "react-responsive-modal";
import Select from "react-select";
import { Container } from "react-grid-system";
import { lighten } from "polished";
import Settings from "../../shared/settings";
import Colors from "../../shared/colors";
import "./pagination.css";
import Loading from "../../components/loading/loading.component";
import Checkbox from "../../components/checkbox/checkbox";
import All from "../../images/categoryIcons/ic-all-category.svg";
import NetIconMembro from "../../assets/images/Icons Network/ic-badge-membro.svg";
import NetIconInscrito from "../../assets/images/Icons Network/ic-badge.inscrito.svg";
import GoChevronLeft from "react-icons/lib/go/chevron-left";
import GoChevronRight from "react-icons/lib/go/chevron-right";
import MdErrorOutline from "react-icons/lib/md/error-outline";

class List extends Component {
  state = {
    status: 0,
    statusCategory: 0,
    statusCountry: 0,
    filterError: false,
    isLoading: false,
    dataCountryDisplay1: "",
    dataCountryDisplay2: "",
    dataCountryDisplay2Value: "",
    selectOtherCountries: false,
    dataList: "",
    selectedCategory: parseInt(
      JSON.parse(localStorage.getItem("selectedCategory")),
      0
    ),
    selectedMember: JSON.parse(localStorage.getItem("selectedMember")),
    selectedCountry: JSON.parse(localStorage.getItem("selectedCountry")),
    selectedQualification: JSON.parse(
      localStorage.getItem("selectedQualification")
    ),
    selectedArea: JSON.parse(localStorage.getItem("selectedArea")),
    selectedTime: JSON.parse(localStorage.getItem("selectedTime")) || "",
    countryValueDrop: JSON.parse(localStorage.getItem("countryValueDrop")),
    isFilter: localStorage.getItem("isFilter"),
    totalPages: "",
    totalItems: "",
    page: parseInt(localStorage.getItem("page"), 0),
    order: parseInt(localStorage.getItem("order"), 0),
    prevOrder: this.props.order,
    location: null,
  };

  componentDidUpdate() {
    const { page, prevOrder } = this.state;

    const { to, order, i18n, perPage } = this.props;

    if (order !== prevOrder) {
      this.getList(
        to,
        order,
        this.defineUrl(to, i18n, page, perPage, order),
        true
      );

      // Atualiza o estado de 'prevOrder' para o valor atual de 'order'
      this.setState({ prevOrder: order });
    }
  }

  componentDidMount() {
    const { page, isFilter } = this.state;

    const { i18n, to, order, perPage } = this.props;

    if (to === "products") {
      this.getCategories(1);
    } else {
      this.getCategories(2);
    }

    this.getCountries();

    if (isFilter) {
      this.getList(to, order, this.defineUrl(to, i18n, page, perPage), true);
    } else {
      this.getList(to, order, this.defineUrl(to, i18n, page, perPage), false);
    }

    this.getLocation();
    this.changeCategory(0)

  }

  getLocation = async () => {
    try {
      const res = await axios.get("https://ipwhois.app/json/");
      this.setState({ location: res.data.country });
    } catch (error) {
      console.error("ipwhois.io service failed, switching to ipapi.co: ", error);
      try {
        const res = await axios.get("https://ipapi.co/json/");
        this.setState({ location: res.data.country_name });
      } catch (error) {
        console.error("ipapi.co service also failed: ", error);
      }
    }
  
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  showPosition = (position) => {
    localStorage.setItem("latitude", position.coords.latitude);
    localStorage.setItem("longitude", position.coords.longitude);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { order, open } = this.state;

    const newOpen = nextProps.open;
    if (open !== newOpen) {
      this.setState({
        open: newOpen,
      });
    }

    const newOrder = nextProps.order;
    if (order !== newOrder) {
      this.setState(
        {
          order: newOrder,
        },
        () => {
          const { order, page } = this.state;

          const { to, i18n, perPage } = this.props;

          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            true
          );
        }
      );
    }
  }

  getCategories = (type) => {
    const { i18n } = this.props;

    const url =
      Settings.server +
      "/api/v1/category?lang=" +
      i18n.language +
      "&type=" +
      type;

    axios
      .get(url)
      .then((result) => {
        this.setState({
          dataCategory: result.data,
          statusCategory: 1,
        });
      })
      .catch(
        this.setState({
          statusCategory: 2,
        })
      );
  };

  getCountries = () => {
    const { i18n } = this.props;
    const lang = i18n.language;
    const url =
      Settings.server +
      "/api/v1/country?expand=translations&lang=" +
      i18n.language +
      "&display=1";

    axios
      .get(url)
      .then((result) => {
        const countries = result.data;
        const countriesFormatDisplay1 = [];
        const countriesFormatDisplay2 = [];

        for (let i = 0; i <= countries.length - 1; i++) {
          if (countries[i].name != null) {
            if (countries[i].translations.length > 1) {
              for (let e = 0; e <= countries[i].translations.length - 1; e++) {
                const getLang = countries[i].translations[e].lang_id.split("-");

                if (getLang[0] === lang) {
                  if (countries[i].display === 1) {
                    countriesFormatDisplay1.push({
                      country_id: countries[i].translations[e].country_id,
                      value: countries[i].translations[e].name,
                      label: countries[i].translations[e].name,
                      search: countries[i].translations[1].name,
                      display: countries[i].display,
                    });
                  } else {
                    countriesFormatDisplay2.push({
                      country_id: countries[i].translations[e].country_id,
                      value: countries[i].translations[e].name,
                      label: countries[i].translations[e].name,
                      search: countries[i].translations[1].name,
                      display: countries[i].display,
                    });
                  }
                }
              }
            }
          }

          if (i === countries.length - 1) {
            countriesFormatDisplay1.sort((a, b) => {
              return a.value.localeCompare(b.value);
            });

            countriesFormatDisplay2.sort((a, b) => {
              return a.value.localeCompare(b.value);
            });

            if (this.state.countryValueDrop.length > 0) {
              this.changeCountryOther();
            }

            this.setState({
              dataCountryDisplay1: countriesFormatDisplay1,
              dataCountryDisplay2: countriesFormatDisplay2,
              statusCountry: 1,
            });
          }
        }
      })
      .catch(
        this.setState({
          statusCountry: 2,
        })
      );
  };

  defineUrl = (to, i18n, pageNumber, perPage) => {
    if (to === "restaurants") {
      return (
        Settings.server +
        "/api/v1/restaurant?expand=media&lang=" +
        i18n.language +
        "&per-page=" +
        perPage +
        "&page=" +
        pageNumber +
        "&approved=1"
      );
    } else if (to === "products") {
      return (
        Settings.server +
        "/api/v1/product?expand=media&lang=" +
        i18n.language +
        "&officialized=1&per-page=" +
        perPage +
        "&page=" +
        pageNumber +
        "&category=0"
      );
    } else if (to === "recipes") {
      return (
        Settings.server +
        "/api/v1/recipe?expand=media&lang=" +
        i18n.language +
        "&per-page=" +
        perPage +
        "&page=" +
        pageNumber
      );
    } else {
      return (
        Settings.server +
        "/api/v1/events?expand=media&lang=" +
        i18n.language +
        "&per-page=" +
        perPage +
        "&page=" +
        pageNumber
      );
    }
  };

  sortLocationsByDistance(locations, point) {
    // Convert coordinates to radians
    const lat1 = (point.latitude * Math.PI) / 180;
    const lon1 = (point.longitude * Math.PI) / 180;

    // Haversine formula
    const getDistance = (location) => {
      const lat2 = (location.coordinates.lat * Math.PI) / 180;
      const lon2 = (location.coordinates.lon * Math.PI) / 180;
      const a =
        Math.sin((lat2 - lat1) / 2) * Math.sin((lat2 - lat1) / 2) +
        Math.cos(lat1) *
          Math.cos(lat2) *
          Math.sin((lon2 - lon1) / 2) *
          Math.sin((lon2 - lon1) / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = 6371e3 * c;
      return d;
    };

    // Sort the locations by distance
    locations.sort((a, b) => getDistance(a) - getDistance(b));
    return locations;
  }

  getList = (to, order, url, isFilter) => {
    const {
      selectedCategory,
      selectedMember,
      selectedCountry,
      selectedQualification,
      selectedArea,
      selectedTime,
      prevOrder,
    } = this.state;

    let orderToText = "";
    let urlConcat = url;
    let join = "";

    // SET ORDER
    if (order === 0) {
      orderToText = "&sort=country";
      urlConcat = urlConcat.concat(orderToText);
    } else if (order === 1) {
      orderToText = "";
      urlConcat = urlConcat.concat(orderToText);
    } else if (order === 2) {
      orderToText = "";
      urlConcat = urlConcat.concat(orderToText);
    } else if (order === 3) {
      orderToText = "&sort=name";
      urlConcat = urlConcat.concat(orderToText);
    } else {
      orderToText = "&sort=-name";
      urlConcat = urlConcat.concat(orderToText);
    }

    // RESTAURANTS
    if (to === "restaurants") {
      if (isFilter) {
        // FILTERS
        selectedCountry.forEach((value, index) => {
          if (index !== 0) {
            if (value === true) {
              join += "&country_id[]=" + index;
            }
          }
        });
        selectedMember.forEach((value, index) => {
          if (index !== 0) {
            if (value === true) {
              join += "&network[]=" + index;
            }
          }
        });

        let finalUrl = urlConcat.concat(join);
        axios
          .get(finalUrl)
          .then((result) => {
            if (order !== prevOrder) {
              this.setState({
                status: 1,
                isLoading: false,
                dataList: result.data,
                totalPages: result.headers["x-pagination-page-count"],
                totalItems: result.headers["x-pagination-total-count"],
              });
            } else {
              const point = {
                latitude: localStorage.getItem("latitude"),
                longitude: localStorage.getItem("longitude"),
              };
              this.sortLocationsByDistance(result.data, point);
              this.setState({
                status: 1,
                isLoading: false,
                dataList: result.data,
                totalPages: result.headers["x-pagination-page-count"],
                totalItems: result.headers["x-pagination-total-count"],
              });
            }
          })
          .catch((error) => {
            this.setState({
              isLoading: false,
              filterError: true,
            });
          });
      } else {
        axios
          .get(urlConcat)
          .then((result) => {
            this.setState({
              status: 1,
              dataList: result.data,
              totalPages: result.headers["x-pagination-page-count"],
              totalItems: result.headers["x-pagination-total-count"],
            });
          })
          .catch((error) => {
            this.setState({
              status: 2,
            });
          });
      }
    }
    // PRODUCTS
    else if (to === "products") {
      if (isFilter) {
        // FILTERS
        if (selectedCategory !== 0) {
          join += "&category_id=" + selectedCategory;
        }

        selectedQualification.forEach((value, index) => {
          if (index !== 0) {
            if (value === true) {
              join += "&qualification[]=" + index;
            }
          }
        });
        selectedArea.forEach((value, index) => {
          if (index !== 0) {
            if (value === true) {
              join += "&region[]=" + index;
            }
          }
        });

        let finalUrl = urlConcat.concat(join);

        axios
          .get(finalUrl)
          .then((result) => {
            this.setState({
              status: 1,
              isLoading: false,
              dataList: result.data,
              totalPages: result.headers["x-pagination-page-count"],
              totalItems: result.headers["x-pagination-total-count"],
            });
          })
          .catch((error) => {
            this.setState({
              status: 2,
              isLoading: false,
              filterError: true,
            });
          });
      } else {
        axios
          .get(urlConcat)
          .then((result) => {
            this.setState({
              status: 1,
              dataList: result.data,
              totalPages: result.headers["x-pagination-page-count"],
              totalItems: result.headers["x-pagination-total-count"],
            });
          })
          .catch((error) => {
            this.setState({
              status: 2,
            });
          });
      }
    }
    // RECIPES
    else if (to === "recipes") {
      if (isFilter) {
        // FILTERS
        if (selectedCategory !== 0) {
          join += "&category_id=" + selectedCategory;
        }
        join += "&cooking_time=" + selectedTime;

        selectedArea.forEach((value, index) => {
          if (index !== 0) {
            if (value === true) {
              join += "&region[]=" + index;
            }
          }
        });

        let finalUrl = urlConcat.concat(join);
        axios
          .get(finalUrl)
          .then((result) => {
            this.setState({
              status: 1,
              isLoading: false,
              dataList: result.data,
              totalPages: result.headers["x-pagination-page-count"],
              totalItems: result.headers["x-pagination-total-count"],
            });
          })
          .catch((error) => {
            this.setState({
              isLoading: false,
              filterError: true,
            });
          });
      } else {
        axios
          .get(urlConcat)
          .then((result) => {
            this.setState({
              status: 1,
              dataList: result.data,
              totalPages: result.headers["x-pagination-page-count"],
              totalItems: result.headers["x-pagination-total-count"],
            });
          })
          .catch((error) => {
            this.setState({
              status: 2,
            });
          });
      }
    }
  };

  resetFilters = () => {
    this.setState(
      {
        selectedCategory: 0,
        selectedMember: [true],
        selectedCountry: [true],
        selectedQualification: [true],
        selectedArea: [true],
        page: 1,
        isFilter: false,
      },
      () => {
        const { order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem("selectedCategory", 0);
        localStorage.setItem("selectedMember", JSON.stringify([true]));
        localStorage.setItem("selectedCountry", JSON.stringify([true]));
        localStorage.setItem("selectedQualification", JSON.stringify([true]));
        localStorage.setItem("selectedArea", JSON.stringify([true]));
        localStorage.setItem("page", 1);
        localStorage.setItem("order", 0);
        localStorage.setItem("isFilter", false);
        localStorage.setItem("countryValueDrop", JSON.stringify([]));
        this.changeCountryOther();
        this.getList(to, order, this.defineUrl(to, i18n, page, perPage), false);
      }
    );
  };

  changeCategory = (value) => {
    this.setState(
      {
        selectedCategory: value,
        page: 1,
      },
      () => {
        const { selectedCategory, order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem("selectedCategory", selectedCategory);
        localStorage.setItem("isFilter", true);
        localStorage.setItem("page", page);

        if (value === 0) {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            false
          );
        } else {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            true
          );
        }
      }
    );
  };

  changeQualification = (index) => {
    const { selectedQualification } = this.state;

    let qualification = selectedQualification;

    if (qualification[index]) {
      if (index !== 0) {
        qualification[index] = false;
        let findTrue = qualification.indexOf(true);
        if (findTrue === -1) {
          qualification = [];
          qualification = [true];
        }
      }
    } else {
      if (index !== 0) {
        qualification[0] = false;
        qualification[index] = true;
      } else {
        qualification = [];
        qualification[index] = true;
      }
    }

    this.setState(
      {
        selectedQualification: qualification,
        page: 1,
      },
      () => {
        const { selectedQualification, order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem(
          "selectedQualification",
          JSON.stringify(selectedQualification)
        );
        localStorage.setItem("isFilter", true);
        localStorage.setItem("page", page);

        if (index === 0) {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            false
          );
        } else {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            true
          );
        }
      }
    );
  };

  changeArea = (index) => {
    const { selectedArea } = this.state;

    let area = selectedArea;

    if (area[index]) {
      if (index !== 0) {
        area[index] = false;
        let findTrue = area.indexOf(true);
        if (findTrue === -1) {
          area = [true];
        }
      }
    } else {
      if (index !== 0) {
        area[0] = false;
        area[index] = true;
      } else {
        area = [];
        area[index] = true;
      }
    }

    this.setState(
      {
        selectedArea: area,
        page: 1,
      },
      () => {
        const { selectedArea, order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem("selectedArea", JSON.stringify(selectedArea));
        localStorage.setItem("isFilter", true);
        localStorage.setItem("page", page);

        if (index === 0) {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            false
          );
        } else {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            true
          );
        }
      }
    );
  };

  changeTime = (value) => {
    this.setState(
      {
        selectedTime: value,
        page: 1,
      },
      () => {
        const { selectedTime, order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem("selectedTime", JSON.stringify(selectedTime));
        localStorage.setItem("isFilter", true);
        localStorage.setItem("page", page);
        this.getList(to, order, this.defineUrl(to, i18n, page, perPage), true);
      }
    );
  };

  changeMember = (index) => {
    const { selectedMember } = this.state;

    let member = selectedMember;

    if (member[index]) {
      if (index !== 0) {
        member[index] = false;
        let findTrue = member.indexOf(true);
        if (findTrue === -1) {
          member = [true];
        }
      }
    } else {
      if (index !== 0) {
        member[0] = false;
        member[index] = true;
      } else {
        member = [];
        member[index] = true;
      }
    }

    this.setState(
      {
        selectedMember: member,
        page: 1,
      },
      () => {
        const { selectedMember, order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem("selectedMember", JSON.stringify(selectedMember));
        localStorage.setItem("isFilter", true);
        localStorage.setItem("page", page);

        if (index === 0) {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            false
          );
        } else {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            true
          );
        }
      }
    );
  };

  changeCountry = (index, type) => {
    const { selectedCountry } = this.state;

    let country = selectedCountry;

    if (country[index]) {
      if (index !== 0) {
        country[index] = false;
        let findTrue = country.indexOf(true);
        if (findTrue === -1) {
          country = [true];
        }
      }
    } else {
      if (index !== 0) {
        country[0] = false;
        country[index] = true;
      } else {
        country = [];
        country = [true];

        this.setState({
          countryValueDrop: [],
          selectOtherCountries: false,
        });
      }
    }

    this.setState(
      {
        selectedCountry: country,
        page: 1,
      },
      () => {
        const { selectedCountry, order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem(
          "selectedCountry",
          JSON.stringify(selectedCountry)
        );
        localStorage.setItem("isFilter", true);
        localStorage.setItem("page", page);

        if (index === 0) {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            false
          );
        } else {
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            true
          );
        }
      }
    );
  };

  changeCountryOther = () => {
    this.setState({
      selectOtherCountries: !this.state.selectOtherCountries,
    });
  };

  onChangeCountryDrop = (value) => {
    const { selectedCountry } = this.state;

    let country = selectedCountry;

    if (value.length > 0) {
      value.forEach((selectedCountry) => {
        if (country[selectedCountry.country_id]) {
          if (selectedCountry.country_id !== 0) {
            country[selectedCountry.country_id] = false;
            let findTrue = country.indexOf(true);
            if (findTrue === -1) {
              country = [];
              country[0] = true;
            }
          }
        } else {
          if (selectedCountry.country_id !== 0) {
            country[0] = false;
            country[selectedCountry.country_id] = true;
          } else {
            country = [];
            country[selectedCountry.country_id] = true;
          }
        }
      });
    } else {
      let findTrue = selectedCountry.indexOf(true);
      if (findTrue === -1) {
        this.setState({
          selectOtherCountries: false,
        });
      } else {
        country = [true];
        this.setState({
          selectOtherCountries: false,
        });
      }
    }

    this.setState(
      {
        selectedCountry: country,
        countryValueDrop: value,
        page: 1,
      },
      () => {
        const { selectedCountry, order, page } = this.state;

        const { i18n, to, perPage } = this.props;

        localStorage.setItem(
          "selectedCountry",
          JSON.stringify(selectedCountry)
        );
        localStorage.setItem("isFilter", true);
        localStorage.setItem("page", page);
        localStorage.setItem("countryValueDrop", JSON.stringify(value));
        this.getList(to, order, this.defineUrl(to, i18n, page, perPage), true);
      }
    );
  };

  /* CHANGE PAGE */
  onChangePage = (e, i) => {
    this.setState(
      {
        page: e,
      },
      () => {
        const { order, page } = this.state;

        const { to, i18n, perPage } = this.props;

        localStorage.setItem("page", page);

        this.getList(to, order, this.defineUrl(to, i18n, page, perPage), true);
        setTimeout(() => {
          var el = document.getElementById("goToTop");
          window.scrollTo({
            top: el.offsetTop - 30,
            behavior: "smooth",
          });
        }, 300);
      }
    );
  };

  /* NEXT PAGE */
  nextPage = () => {
    const { page, totalPages } = this.state;

    if (page + 1 <= totalPages) {
      this.setState(
        {
          page: page + 1,
        },
        () => {
          const { page, order, isFilter } = this.state;

          const { to, i18n, perPage } = this.props;

          localStorage.setItem("page", page);
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            isFilter
          );
          setTimeout(() => {
            var el = document.getElementById("goToTop");
            window.scrollTo({
              top: el.offsetTop - 30,
              behavior: "smooth",
            });
          }, 300);
        }
      );
    }
  };

  /* PREVIOUS PAGE */
  previousPage = () => {
    const { page } = this.state;

    if (page - 1 > 0) {
      this.setState(
        {
          page: page - 1,
        },
        () => {
          const { page, order, isFilter } = this.state;

          const { to, i18n, perPage } = this.props;

          localStorage.setItem("page", page);
          this.getList(
            to,
            order,
            this.defineUrl(to, i18n, page, perPage),
            isFilter
          );
          setTimeout(() => {
            var el = document.getElementById("goToTop");
            window.scrollTo({
              top: el.offsetTop - 30,
              behavior: "smooth",
            });
          }, 300);
        }
      );
    }
  };

  render() {
    const {
      status,
      statusCategory,
      statusCountry,
      filterError,
      isLoading,
      dataCountryDisplay1,
      dataCountryDisplay2,
      countryValueDrop,
      selectOtherCountries,
      dataCategory,
      dataList,
      isFilter,
      selectedCategory,
      selectedMember,
      selectedCountry,
      selectedQualification,
      selectedArea,
      selectedTime,
      totalPages,
      totalItems,
      page,
      location,
    } = this.state;

    const {
      t,
      match,
      to,
      filter,
      activeCategory,
      activeMember,
      activeCountry,
      activeQualification,
      activeArea,
      activeTime,
      pagination,
      perPage,
      open,
      close,
    } = this.props;
    const RightCol = styled.div`
      width: ${filter ? "calc(75% + 30px)" : ""};
      margin-left: -10px;
      margin-right: -10px;
      padding-top: 10px;
      position: relative;

      @media screen and (max-width: 992px) {
        width: ${filter ? "calc(65% + 30px);" : "100%"};
      }

      @media screen and (max-width: 767px) {
        width: 100%;
        margin-left: 0px;
        margin-right: 0px;
      }
    `;
    const ListItem = styled.div`
      width: ${filter ? "calc(33.3% - 20px)" : "calc(25% - 20px)"};
      height: 300px;
      margin-left: 10px;
      margin-right: 10px;
      margin-top: 10px;
      margin-bottom: 20px;
      cursor: pointer;

      @media screen and (max-width: 992px) {
        width: calc(50% - 20px);
      }

      @media screen and (max-width: 767px) {
        width: 100%;
        margin: 0;
        margin-bottom: 20px;
      }
    `;
    const FilterContent = styled.div``;
    const LeftButton = styled.div`
      width: 100px;
      height: 40px;
      border-radius: 4px;
      background-color: ${page > 1 ? Colors.primary : Colors.secondary};
      cursor: ${page === 1 ? "" : "pointer"};
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
      transition: all 0.2s ease;

      &:hover {
        background-color: ${page > 1
          ? lighten(0.05, Colors.primary)
          : lighten(0.05, Colors.secondary)};
      }

      @media screen and (max-width: 992px) {
        display: none;
      }
    `;
    const RightButton = styled.div`
      width: 100px;
      height: 40px;
      border-radius: 4px;
      background-color: ${page === totalPages
        ? Colors.secondary
        : Colors.primary};
      cursor: ${page === totalPages ? "" : "pointer"};
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
      transition: all 0.2s ease;

      &:hover {
        background-color: ${page === totalPages
          ? lighten(0.05, Colors.secondary)
          : lighten(0.05, Colors.primary)};
      }

      @media screen and (max-width: 992px) {
        display: none;
      }
    `;

    const modal = {
      width: "100%",
    };

    const preloader = () => (
      <LoadingImage>
        <Loading />
      </LoadingImage>
    );

    return (
      <Container id="goToTop">
        <Space></Space>
        {status === 0 && (
          <LoadingPage>
            <Loading />
          </LoadingPage>
        )}
        {status === 1 && (
          <ContentList>
            {filter && open === false && (
              <LeftCol>
                <HeaderFilter>
                  <TitleFilter>{t("Filtrar")}</TitleFilter>
                  <ResetFilter onClick={this.resetFilters}>
                    {t("Limpar Filtros")}
                  </ResetFilter>
                </HeaderFilter>
                <FilterContent>
                  {/* CATEGORIAS */}
                  {activeCategory && statusCategory === 1 && (
                    <SectionFilter>
                      <SectionTitle>{t("Categorias")}</SectionTitle>
                      <SectionContent>
                        <CategoryItem onClick={() => this.changeCategory(0)}>
                          <CategoryIcon>
                            <img src={All} alt={t("Todas as categorias")} />
                          </CategoryIcon>
                          <CategoryText
                            className={
                              selectedCategory === 0
                                ? "activeFilterCategory"
                                : ""
                            }
                          >
                            {t("Todas as categorias")}
                          </CategoryText>
                        </CategoryItem>
                        {dataCategory.map((category, index) => {
                          return (
                            <CategoryItem
                              onClick={() => this.changeCategory(category.id)}
                              key={index}
                            >
                              <CategoryIcon>
                                <img src={category.icon} alt={category.name} />
                              </CategoryIcon>
                              <CategoryText
                                className={
                                  selectedCategory === category.id
                                    ? "activeFilterCategory"
                                    : ""
                                }
                              >
                                {category.name}
                              </CategoryText>
                            </CategoryItem>
                          );
                        })}
                      </SectionContent>
                    </SectionFilter>
                  )}
                  {/* TIPO DE QUALIFICAÇÃO */}
                  {activeQualification && (
                    <SectionFilter>
                      <SectionTitle>{t("Tipo de qualificação")}</SectionTitle>
                      <SectionContent>
                        <CheckboxContent>
                          <Checkbox
                            index="0"
                            value={selectedQualification[0]}
                            onChange={() => this.changeQualification(0)}
                          />
                          <TextCheckbox>{t("Todos os tipos")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="1"
                            value={selectedQualification[1]}
                            onChange={() => this.changeQualification(1)}
                          />
                          <TextCheckbox>DOP</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="2"
                            value={selectedQualification[2]}
                            onChange={() => this.changeQualification(2)}
                          />
                          <TextCheckbox>ETG</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="2"
                            value={selectedQualification[3]}
                            onChange={() => this.changeQualification(3)}
                          />
                          <TextCheckbox>IGP</TextCheckbox>
                        </CheckboxContent>
                      </SectionContent>
                    </SectionFilter>
                  )}
                  {/* ÁREA GEOGRÁFICA*/}
                  {activeArea && (
                    <SectionFilter>
                      <SectionTitle>{t("Área geográfica")}</SectionTitle>
                      <SectionContent>
                        <CheckboxContent>
                          <Checkbox
                            index="0"
                            value={selectedArea[0]}
                            onChange={() => this.changeArea(0)}
                          />
                          <TextCheckbox>{t("Todos os áreas")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="1"
                            value={selectedArea[1]}
                            onChange={() => this.changeArea(1)}
                          />
                          <TextCheckbox>{t("Norte")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="2"
                            value={selectedArea[2]}
                            onChange={() => this.changeArea(2)}
                          />
                          <TextCheckbox>{t("Centro")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="2"
                            value={selectedArea[3]}
                            onChange={() => this.changeArea(3)}
                          />
                          <TextCheckbox>{t("Alentejo")}</TextCheckbox>
                        </CheckboxContent>
                      </SectionContent>
                    </SectionFilter>
                  )}
                  {/* Filtro por Tempo */}
                  {activeTime && (
                    <SectionFilter>
                      <SectionTitle>{t("tempo_de_confecao")}</SectionTitle>
                      <SectionContent>
                        <CheckboxContent>
                          <Checkbox
                            index="0"
                            value={selectedTime === ""}
                            onChange={() => this.changeTime("")}
                          />
                          <TextCheckbox>{t("all_recipes")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="1"
                            value={selectedTime === "Rápido"}
                            onChange={() => this.changeTime("Rápido")}
                          />
                          <TextCheckbox>{t("Fast")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="2"
                            value={selectedTime === "Média"}
                            onChange={() => this.changeTime("Média")}
                          />
                          <TextCheckbox>{t("Medium")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="3"
                            value={selectedTime === "Demorado"}
                            onChange={() => this.changeTime("Demorado")}
                          />
                          <TextCheckbox>{t("Slow")}</TextCheckbox>
                        </CheckboxContent>
                      </SectionContent>
                    </SectionFilter>
                  )}
                  {/* MEMBRO */}
                  {activeMember && (
                    <SectionFilter>
                      <SectionTitle>{t("type_of_member")}</SectionTitle>
                      <SectionContent>
                        <CheckboxContent>
                          <Checkbox
                            index="0"
                            value={selectedMember[0]}
                            onChange={() => this.changeMember(0)}
                          />
                          <TextCheckbox>{t("all_types")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="1"
                            value={selectedMember[1]}
                            onChange={() => this.changeMember(1)}
                          />
                          <TextCheckbox>{t("network_member")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="2"
                            value={selectedMember[2]}
                            onChange={() => this.changeMember(2)}
                          />
                          <TextCheckbox>{t("subscribers")}</TextCheckbox>
                        </CheckboxContent>
                        <CheckboxContent>
                          <Checkbox
                            index="2"
                            value={selectedMember[3]}
                            onChange={() => this.changeMember(3)}
                          />
                          <TextCheckbox>{t("Convidados")}</TextCheckbox>
                        </CheckboxContent>
                      </SectionContent>
                    </SectionFilter>
                  )}
                  {/* COUNTRY */}
                  {activeCountry && statusCountry === 1 && (
                    <SectionFilter>
                      <SectionTitle>{t("País")}</SectionTitle>
                      <SectionContent>
                        <CheckboxContent>
                          <Checkbox
                            value={selectedCountry[0]}
                            onChange={() => this.changeCountry(0)}
                          />
                          <TextCheckbox>{t("Todos os países")}</TextCheckbox>
                        </CheckboxContent>
                        {dataCountryDisplay1.map((country, index) => {
                          return (
                            country.display === 1 && (
                              <CheckboxContent key={index}>
                                <Checkbox
                                  value={
                                    location && location === country.value
                                      ? 1
                                      : selectedCountry[country.country_id]
                                  }
                                  onChange={(id, type) =>
                                    this.changeCountry(country.country_id, 1)
                                  }
                                />
                                <TextCheckbox>{country.value}</TextCheckbox>
                              </CheckboxContent>
                            )
                          );
                        })}
                        <CheckboxContent>
                          <Checkbox
                            value={selectOtherCountries}
                            onChange={() => this.changeCountryOther()}
                          />
                          <TextCheckbox>{t("OutrosPaises")}</TextCheckbox>
                        </CheckboxContent>
                        {/* DROPDOWN */}
                        {selectOtherCountries && (
                          <CountriesOther>
                            <Select
                              placeholder="Selecionar"
                              clearable={false}
                              onChange={(value, type) =>
                                this.onChangeCountryDrop(value)
                              }
                              options={dataCountryDisplay2}
                              value={countryValueDrop}
                              autoBlur={false}
                              multi
                            />
                          </CountriesOther>
                        )}
                      </SectionContent>
                    </SectionFilter>
                  )}
                </FilterContent>
              </LeftCol>
            )}
            <RightCol className={isLoading ? "loading" : ""}>
              {/* ERROR ON FILTER */}
              {filterError && (
                <ErrorPage>{t("Ocorreu um erro. Tente novamente")}</ErrorPage>
              )}
              {/* RESTAURANTES */}
              {to === "restaurants" && (
                <span>
                  {dataList.length > 0 && (
                    <ListItems>
                      {dataList.map((restaurant, index) => {
                        return (
                          <ListItem key={index}>
                            <Link to={`${match}/${restaurant.slug}`}>
                              <Image>
                                <ImageLoader
                                  src={restaurant.media[2][0].path}
                                  alt={restaurant.name}
                                  wrapper={React.createFactory("div")}
                                  preloader={preloader}
                                >
                                  <FailedLoadImage>
                                    <div>
                                      <FailedLoadImageIcon>
                                        <MdErrorOutline />
                                      </FailedLoadImageIcon>
                                      {t("Erro ao carregar a imagem")}
                                    </div>
                                  </FailedLoadImage>
                                </ImageLoader>
                              </Image>
                              <Info>
                                <Info1>
                                  {restaurant.network === 1 && (
                                    <img src={NetIconMembro} alt="" />
                                  )}
                                  {restaurant.network === 2 && (
                                    <img src={NetIconInscrito} alt="" />
                                  )}
                                  <p>{restaurant.name}</p>
                                </Info1>
                                <Info3>{restaurant.country}</Info3>
                              </Info>
                            </Link>
                          </ListItem>
                        );
                      })}
                    </ListItems>
                  )}
                </span>
              )}
              {/* PRODUCTS */}
              {to === "products" && (
                <span>
                  {dataList.length > 0 && (
                    <ListItems>
                      {dataList.map((product, index) => {
                        return (
                          <ListItem key={index}>
                            <Link to={`${match}/${product.slug}`}>
                              <Image>
                                <ImageLoader
                                  src={product.media[4][0].path}
                                  alt={product.name}
                                  wrapper={React.createFactory("div")}
                                  preloader={preloader}
                                >
                                  <FailedLoadImage>
                                    <div>
                                      <FailedLoadImageIcon>
                                        <MdErrorOutline />
                                      </FailedLoadImageIcon>
                                      {t("Erro ao carregar a imagem")}
                                    </div>
                                  </FailedLoadImage>
                                </ImageLoader>
                              </Image>
                              <Info>
                                <Info1>
                                  <p>{product.name}</p>
                                </Info1>
                                {product.region != null && (
                                  <Info2>
                                    {product.region === 1 && t("Norte")}
                                    {product.region === 2 && t("Centro")}
                                    {product.region === 3 && t("Alentejo")}
                                  </Info2>
                                )}
                                {product.category !== null && (
                                  <Info3>{product.category.name}</Info3>
                                )}
                              </Info>
                            </Link>
                          </ListItem>
                        );
                      })}
                    </ListItems>
                  )}
                </span>
              )}
              {/* RECIPES */}
              {to === "recipes" && (
                <span>
                  {dataList.length > 0 && (
                    <ListItems>
                      {dataList.map((recipe, index) => {
                        return (
                          <ListItem key={index}>
                            <Link to={`${match}/${recipe.slug}`}>
                              <Image>
                                <ImageLoader
                                  src={recipe.media[2][0].path}
                                  alt={recipe.name}
                                  wrapper={React.createFactory("div")}
                                  preloader={preloader}
                                >
                                  <FailedLoadImage>
                                    <div>
                                      <FailedLoadImageIcon>
                                        <MdErrorOutline />
                                      </FailedLoadImageIcon>
                                      {t("Erro ao carregar a imagem")}
                                    </div>
                                  </FailedLoadImage>
                                </ImageLoader>
                              </Image>
                              <Info>
                                <Info1>
                                  <p>{recipe.name}</p>
                                </Info1>
                                {recipe.region !== null && (
                                  <Info2>
                                    {recipe.region === 1 && "Norte"}
                                    {recipe.region === 2 && "Centro"}
                                    {recipe.region === 3 && "Alentejo"}
                                  </Info2>
                                )}
                                {(recipe.number_people !== null ||
                                  recipe.time.cooking_time !== null) && (
                                  <Info3>
                                    {recipe.number_people !== null &&
                                      recipe.number_people + " " + t("pessoas")}
                                    {recipe.time.cooking_time !== null &&
                                      " | " + recipe.time.cooking_time}
                                  </Info3>
                                )}
                              </Info>
                            </Link>
                          </ListItem>
                        );
                      })}
                    </ListItems>
                  )}
                </span>
              )}
              {/* NO RESULTS */}
              {dataList.length === 0 && (
                <span>
                  {isFilter ? (
                    <NoResults>
                      {t(
                        "Não foram encontrados resultados com os filtro aplicados"
                      )}
                    </NoResults>
                  ) : (
                    <NoResults>{t("Sem resultados")}</NoResults>
                  )}
                </span>
              )}
              {/* PAGINATION */}
              {totalPages > 1 && (
                <span>
                  {pagination && (
                    <PaginationWrapper>
                      <LeftButton onClick={this.previousPage}>
                        <ButtonIcon className="fixLeft">
                          <GoChevronLeft />
                        </ButtonIcon>
                        <ButtonText>{t("Anterior")}</ButtonText>
                      </LeftButton>
                      <Pagination
                        total={Number(totalItems)}
                        defaultPageSize={perPage}
                        onChange={this.onChangePage}
                        current={page}
                        className={"pagination"}
                      />
                      <RightButton onClick={this.nextPage}>
                        <ButtonText>{t("Seguinte")}</ButtonText>
                        <ButtonIcon>
                          <GoChevronRight />
                        </ButtonIcon>
                      </RightButton>
                    </PaginationWrapper>
                  )}
                </span>
              )}
            </RightCol>
          </ContentList>
        )}
        {status === 2 && (
          <ErrorPage>{t("Ocorreu um erro. Tente novamente")}</ErrorPage>
        )}

        {/* MODALS */}
        <Modal
          open={open}
          onClose={close}
          styles={{ modal }}
          closeIconSize={16}
          little
        >
          <CardTitle>{t("Filtrar")}</CardTitle>
          {/* CATEGORIAS */}
          {activeCategory && statusCategory === 1 && (
            <SectionFilter>
              <SectionTitle>{t("Categorias")}</SectionTitle>
              <SectionContent>
                <CategoryItem onClick={() => this.changeCategory(0)}>
                  <CategoryIcon>
                    <img src={All} alt={t("Todas as categorias")} />
                  </CategoryIcon>
                  <CategoryText
                    className={
                      selectedCategory === 0 ? "activeFilterCategory" : ""
                    }
                  >
                    {t("Todas as categorias")}
                  </CategoryText>
                </CategoryItem>
                {dataCategory.map((category, index) => {
                  return (
                    <CategoryItem
                      onClick={() => this.changeCategory(category.id)}
                      key={index}
                    >
                      <CategoryIcon>
                        <img src={category.icon} alt={category.name} />
                      </CategoryIcon>
                      <CategoryText
                        className={
                          selectedCategory === category.id
                            ? "activeFilterCategory"
                            : ""
                        }
                      >
                        {category.name}
                      </CategoryText>
                    </CategoryItem>
                  );
                })}
              </SectionContent>
            </SectionFilter>
          )}
          {/* TIPO DE QUALIFICAÇÃO */}
          {activeQualification && (
            <SectionFilter>
              <SectionTitle>{t("Tipo de qualificação")}</SectionTitle>
              <SectionContent>
                <CheckboxContent>
                  <Checkbox
                    value={selectedQualification[0]}
                    onChange={() => this.changeQualification(0)}
                  />
                  <TextCheckbox>{t("Todos os tipos")}</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    value={selectedQualification[1]}
                    onChange={() => this.changeQualification(1)}
                  />
                  <TextCheckbox>DOP</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    value={selectedQualification[2]}
                    onChange={() => this.changeQualification(2)}
                  />
                  <TextCheckbox>ETG</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    value={selectedQualification[3]}
                    onChange={() => this.changeQualification(3)}
                  />
                  <TextCheckbox>IGP</TextCheckbox>
                </CheckboxContent>
              </SectionContent>
            </SectionFilter>
          )}
          {/* ÁREA GEOGRÁFICA*/}
          {activeArea && (
            <SectionFilter>
              <SectionTitle>{t("Área geográfica")}</SectionTitle>
              <SectionContent>
                <CheckboxContent>
                  <Checkbox
                    index="0"
                    value={selectedArea[0]}
                    onChange={() => this.changeArea(0)}
                  />
                  <TextCheckbox>{t("Todos os áreas")}</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    index="1"
                    value={selectedArea[1]}
                    onChange={() => this.changeArea(1)}
                  />
                  <TextCheckbox>{t("Norte")}</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    index="2"
                    value={selectedArea[2]}
                    onChange={() => this.changeArea(2)}
                  />
                  <TextCheckbox>{t("Centro")}</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    index="2"
                    value={selectedArea[3]}
                    onChange={() => this.changeArea(3)}
                  />
                  <TextCheckbox>{t("Alentejo")}</TextCheckbox>
                </CheckboxContent>
              </SectionContent>
            </SectionFilter>
          )}
          {/* Filtro por Tempo */}
          {/* <SectionFilter>
                                <SectionTitle>
                                    {t('Tempo de Confeção')}
                                </SectionTitle>
                                <SectionContent>
                                    <CheckboxContent>
                                        <Checkbox index="0" value={selectedArea[0]} onChange={() => this.changeArea(0)}/>
                                        <TextCheckbox>
                                            {t('Rápido')}
                                        </TextCheckbox>
                                    </CheckboxContent>
                                    <CheckboxContent>
                                        <Checkbox index="1" value={selectedArea[1]} onChange={() => this.changeArea(1)}/>
                                        <TextCheckbox>
                                            {t('Média')}
                                        </TextCheckbox>
                                    </CheckboxContent>
                                    <CheckboxContent>
                                        <Checkbox index="2" value={selectedArea[2]} onChange={() => this.changeArea(2)}/>
                                        <TextCheckbox>
                                            {t('Demorada')}
                                        </TextCheckbox>
                                    </CheckboxContent>

                                </SectionContent>
                            </SectionFilter> */}
          {/* MEMBRO */}
          {activeMember && (
            <SectionFilter>
              <SectionTitle>{t("Tipo de membro")}</SectionTitle>
              <SectionContent>
                <CheckboxContent>
                  <Checkbox
                    index="0"
                    value={selectedMember[0]}
                    onChange={() => this.changeMember(0)}
                  />
                  <TextCheckbox>{t("Todos os tipos")}</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    index="1"
                    value={selectedMember[1]}
                    onChange={() => this.changeMember(1)}
                  />
                  <TextCheckbox>{t("Membro da rede")}</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    index="2"
                    value={selectedMember[2]}
                    onChange={() => this.changeMember(2)}
                  />
                  <TextCheckbox>{t("Inscritos")}</TextCheckbox>
                </CheckboxContent>
                <CheckboxContent>
                  <Checkbox
                    index="2"
                    value={selectedMember[3]}
                    onChange={() => this.changeMember(3)}
                  />
                  <TextCheckbox>{t("Convidados")}</TextCheckbox>
                </CheckboxContent>
              </SectionContent>
            </SectionFilter>
          )}
          {/* COUNTRY */}
          {activeCountry && statusCountry === 1 && (
            <SectionFilter>
              <SectionTitle>{t("País")}</SectionTitle>
              <SectionContent>
                <CheckboxContent>
                  <Checkbox
                    value={selectedCountry[0]}
                    onChange={() => this.changeCountry(0)}
                  />
                  <TextCheckbox>{t("Todos os países")}</TextCheckbox>
                </CheckboxContent>
                {dataCountryDisplay1.map((country, index) => {
                  return (
                    country.display === 1 && (
                      <CheckboxContent key={index}>
                        <Checkbox
                          value={selectedCountry[country.country_id]}
                          onChange={(id, type) =>
                            this.changeCountry(country.country_id, 1)
                          }
                        />
                        <TextCheckbox>{country.value}</TextCheckbox>
                      </CheckboxContent>
                    )
                  );
                })}
                <CheckboxContent>
                  <Checkbox
                    value={selectOtherCountries}
                    onChange={() => this.changeCountryOther()}
                  />
                  <TextCheckbox>{t("OutrosPaises")}</TextCheckbox>
                </CheckboxContent>
                {/* DROPDOWN */}
                {selectOtherCountries && (
                  <CountriesOther>
                    <Select
                      placeholder="Selecionar"
                      clearable={false}
                      onChange={(value, type) =>
                        this.onChangeCountryDrop(value)
                      }
                      options={dataCountryDisplay2}
                      value={countryValueDrop}
                      autoBlur={false}
                      multi
                    />
                  </CountriesOther>
                )}
              </SectionContent>
            </SectionFilter>
          )}
        </Modal>
      </Container>
    );
  }
}

export default List;

const Space = styled.div`
  width: 100%;
  height: 60px;

  @media screen and (max-width: 830px) {
    height: 10px;
  }
`;
const LoadingPage = styled.div`
  height: 300px;
`;
const ErrorPage = styled.div`
  text-align: center;
  width: 100%;
  height: 300px;
  color: #666666;
`;

/* FILTER */
const HeaderFilter = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
  background-color: #fff;
  position: relative;
  z-index: 10;

  @media screen and (max-width: 767px) {
    padding-left: 15px;
    padding-right: 0px;
  }
`;
const TitleFilter = styled.div`
  color: #666666;
  font-family: Bazar;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
`;
const ResetFilter = styled.div`
  color: ${Colors.primary};
  font-family: "PT Sans";
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;
const SectionFilter = styled.div`
  padding: 25px 0px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;
const SectionTitle = styled.div`
  color: #666666;
  font-family: "PT Sans";
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;

  span {
    font-size: 12px;
  }
`;
const SectionContent = styled.div``;
const CheckboxContent = styled.div`
  display: flex;
  align-items: center;
  height: 35px;
`;
const TextCheckbox = styled.div`
  color: #666666;
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 16px;
  margin-left: 5px;
`;
const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
`;
const CategoryIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background-color: ${Colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  img {
    color: #fff;
    fill: white !important;
  }
`;
const CategoryText = styled.div`
  width: calc(100% - 50px);
  color: #666666;
  font-family: "PT Sans";
  font-size: 16px;
  margin-left: 10px;
  text-transform: uppercase;
  transition: all 0.3s ease;
`;

// LIST STRUTURE
const ContentList = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 767px) {
    display: block;
  }
`;
const LeftCol = styled.div`
  width: 20%;

  @media screen and (max-width: 992px) {
    width: 30%;
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
`;
const ListItems = styled.div`
  display: flex;
  flex-flow: row wrap;
`;
const Image = styled.div`
  width: 100%;
  height: 220px;
  overflow: hidden;

  img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    transition: all 0.3s ease-in-out;

    &:hover {
      transform: scale(1.05);
    }
  }
`;
const Info = styled.div`
  background-color: white;
`;
const Info1 = styled.div`
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  align-items: center;

  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0;
    max-width: 255px;
  }

  img {
    margin-right: 5px;
  }
`;
const Info2 = styled.div`
  opacity: 0.6;
  color: #000000;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const Info3 = styled.div`
  opacity: 0.6;
  color: #000000;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

// PAGINATION
const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  margin-left: 10px;
  margin-right: 10px;
  border-top: 1px solid #e6ebec;
  margin-top: 15px;
  margin-bottom: 20px;

  @media screen and (max-width: 992px) {
    justify-content: center;
  }
`;
const ButtonIcon = styled.div`
  color: #ffffff;
  font-size: 20px;
  margin-top: -3px;
`;
const ButtonText = styled.div`
  color: #ffffff;
  font-size: 14px;
`;

// RESULTS
const NoResults = styled.div`
  width: 100%;
  text-align: center;
  color: #666666;
  margin-top: 50px;
`;

// MODAL
const CardTitle = styled.div`
  color: #666666;
  font-family: Bazar;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
  margin-bottom: 20px;
`;

const CountriesOther = styled.div`
  margin-top: 10px;
`;

const LoadingImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
  background-color: #f4f6f7;
`;
const FailedLoadImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
  background-color: #f4f6f7;
  color: hsl(0, 0%, 47%);
  text-align: center;
  font-size: 14px;
`;
const FailedLoadImageIcon = styled.div`
  color: hsl(0, 0%, 47%);
  margin-bottom: 10px;
  font-size: 34px;
`;



// WEBPACK FOOTER //
// ./src/containers/List/list.js